const Joi = require("joi");

const publicUserSchema = (data) => {
  const schema = Joi.object({
    notes: Joi.string()
      .trim()
      .required()
      .when("UserNotes", {
        is: true,
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "any.required": "Please enter Notes.",
        "string.empty": "Please enter Notes.", // Custom message for empty string
      }),

    UserStatus: Joi.number()
      .integer()
      .required()
      .when("settingUserStatus", {
        is: true,
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .custom((value, helpers) => {
        // Trigger error if value is 0
        if (value === 0) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .messages({
        "number.base": "Please select User Status.",
        "any.required": "Please select User Status.",
        "any.invalid": "Please select User Status.", // Custom message when value is 0
      }),

    InmateID: Joi.number()
      .integer()
      .required()
      .when("complementRequired", {
        is: true,
        then: Joi.number().greater(0),
        otherwise: Joi.optional(),
      })
      .custom((value, helpers) => {
        if (value === 0 || value === undefined || value === null) {
          return helpers.error("number.greaterThanZero");
        }
        return value; // Pass validation if value is greater than 0
      })
      .messages({
        "number.base": "Please select Inmate ID.",
        "any.required": "Please select Inmate ID.",
        "number.greaterThanZero": "Please select Inmate ID.",
        "number.greater": "Please select Inmate ID.",
      }),

    ComplementFundAmount: Joi.number()
      .when("complementRequired", {
        is: true,
        then: Joi.number()
          .required()
          .custom((value, helpers) => {
            if (value === 0) {
              return helpers.error("number.greaterThanZero");
            }
            return value; // Pass validation if value is greater than 0
          }),
        otherwise: Joi.number()
          .optional()
          .custom((value, helpers) => {
            if (value === 0) {
              return helpers.error("number.greaterThanZero");
            }
            return value; // Pass validation if value is greater than 0
          }),
      })
      .messages({
        "number.base": "Please enter Complement Fund.",
        "any.required": "Please enter Complement Fund.",
        "number.greaterThanZero": "Please enter Complement Fund.",
      }),

    // date: Joi.string()
    //   .trim()
    //   .required()
    //   .when("eventLogList", {
    //     is: true,
    //     then: Joi.required(),
    //     otherwise: Joi.optional(),
    //   })
    //   .invalid(null, "") // Explicitly mark null and empty string as invalid
    //   .pattern(/^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-\d{4}$/) // MM-DD-YYYY format
    //   .messages({
    //     "any.required": "	Please enter Date.",
    //     "string.empty": "	Please enter Date.",
    //     "any.invalid": "	Please enter Date.", // This catches null and empty cases
    //     "string.pattern.base": "	Please enter Date.",
    //     "string.base": "	Please enter Date.",
    //   }),
    date: Joi.string()
      .trim()
      .required()
      .when("eventLogList", {
        is: true,
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .invalid(null, "") // Explicitly mark null and empty string as invalid
      .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/) // MM/DD/YYYY format
      .messages({
        "any.required": "Please enter Date.",
        "string.empty": "Please enter Date.",
        "any.invalid": "Please enter Date.", // This catches null and empty cases
        "string.pattern.base": "Please enter Date in MM/DD/YYYY format.",
        "string.base": "Please enter Date.",
      }),
  }).unknown(true); // Allow additional fields not defined in the schema

  return schema.validate(data, {
    abortEarly: false, // Validate all fields and return all errors
  });
};

module.exports = publicUserSchema;
